// Stepts for homepage
const onboardingSteps = [
{
    element: ".table",
    popover: {
        className: 'first-step-popover-class',
        title: '🙋<br>Začínáme',
        description: '<b>Na této stránce máš přehled nad všemi lidmi, kde spravuješ preboarding, onboarding a rozvoj zaměstnanců. </b><br><br> Nového zaměstnance přidáš ze záložky "Hiring" (pokud je modul aktivní) a nastavíš mu kolo "K přijetí". Jinak ho lze přidat také pluskem vpravo nahoře 👌',
        position: 'bottom-center',
        showButtons: true,
    },

},
{
    element: ".filters-wrapper",
    popover: {
        title: '🥳<br>Díky timeline máš přehled nad celým průběhem onboardingu',
        description: 'Mezi jednotlivými fázemi onboardingu si můžeš překlikávat a <b>prohlédnout si zaměstnance, kteří právě touto fází procházejí.</b> V červeném kolečku <div class="badge badge-timeline-red"><span>3</span></div> vidíš jejich celkový počet.',
        position: 'bottom-center',
        showButtons: true,
    },
},
{
    element: ".filters-loop-wrapper",
    popover: {
        title: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>',
        description: '<b>Zaměstnanci se po timeline Onboardingu posouvají automaticky.</b> Stačí když jim navolíš datum nástupu do zaměstnání.<br><br><i>Narozdíl od sekce "Hiring", kde si vybíráš, koho a kdy pošleš do dalšího kola.</i>',
        position: 'bottom-center',
        showButtons: true,
    },


},
{
    element: ".table",
    popover: {
        title: '🧑<br>Přehled zaměstnanců',
        description: 'Ke každému zaměstnanci si můžeš přidávat štítky, zkušenosti, ★ hodnocení a vlatní poznámky.',
        position: 'bottom-center',
        showButtons: true,
    },

},
{
    element: ".filters-bar",
    popover: {
        title: ' ',
        description: '<b>Ve výchozím stavu vidíš všechny zaměstnance bez ohledu na pracovní pozici. </b>Doporučujeme vyzkoušet filtr podle pracovní pozice. Snadno tak uvidíš, jak probíhá onboarding různých skupin zaměstnanců. 🙂',
        position: 'bottom',
        showButtons: true,
    },

},
{
    element: ".edit",
    popover: {
        className: 'image-popover',
        title: '<a href="../onboarding?profile=12" target="_blank" title="Více"><img src="/images/guide-onboarding-1.png"></a>',
        description: '<b>Datum nástupu a seznam úkolů pro HR oddělení i zaměstnance </b> můžeš sledovat a editovat kliknutím na ikonu <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-3"><path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path></svg>. ',
        position: 'bottom-right',
        showButtons: true,
    },

},
{
    element: "#sidebar",
    popover: {
        title: 'Paráda!',
        description: 'Prohlédni si, jak je na tom seznam tvých úkolů, které se týkají onboardingu<br>(1 min)<br>',
        position: 'right-center',
        showButtons: true,
        showButtons: true,         // Do not show control buttons in footer
        doneBtnText: 'Ano, pokračovat dál',
        nextBtnText: 'Rozumím',        // Next button text for this step
        prevBtnText: 'Zpět',
    },
    onNext: () => {
        // Prevent moving to the next step
        window.location.assign("/onboarding/checklist#guide");

    }
},
]



export default onboardingSteps
